import React, { useState, useEffect } from 'react';

const TypingAnimation = () => {
    const words = ['resources', 'reports', 'business terms', 'metrics', 'components', 'report categories', 'action plans'];
    const [wordIndex, setWordIndex] = useState(0);
    const [text, setText] = useState('');
    const [isTyping, setIsTyping] = useState(true);

    useEffect(() => {
        const currentWord = words[wordIndex];

        if (isTyping) {
            // Typing animation
            if (text.length < currentWord.length) {
                const timeout = setTimeout(() => {
                    setText(currentWord.slice(0, text.length + 1));
                }, 200); // Typing speed (adjust as needed)

                return () => clearTimeout(timeout);
            } else {
                setIsTyping(false);

                // Delay before backspacing
                setTimeout(() => {
                    setIsTyping(true);
                }, 2000); // Delay before backspacing (2 seconds)
            }
        } else {
            // Backspacing animation
            if (text.length > 0) {
                const timeout = setTimeout(() => {
                    setText(currentWord.slice(0, text.length - 1));
                }, 50); // Backspacing speed (adjust as needed)

                return () => clearTimeout(timeout);
            } else {
                // Move to the next word
                const nextWordIndex = (wordIndex + 1) % words.length;
                setWordIndex(nextWordIndex);
                setIsTyping(true);
            }
        }
    }, [wordIndex, text, isTyping, words]);

    return (
        <div className="loadingResourceInfo">
            <span className="typing-text">loading {text} </span>
            <span className="typing-cursor">_</span>
        </div>
    );
};

export default TypingAnimation;
